import React, {
  createContext, useCallback, useContext, useState,
} from 'react';
import { EmphasizedSnackbar } from 'Packages/FacetDesign/Components/Experimental/EmphasizedSnackbar';
import PropTypes from 'prop-types';

const EmphasizedSnackbarContext = createContext(null);

export function EmphasizedSnackbarContextProvider({ children }) {
  const [items, setItems] = useState(new Set());
  const addItem = useCallback(({ title, description, autoHideDuration }) => {
    setItems((currentItems) => new Set([...Array.from(currentItems), { title, description, autoHideDuration }]));
  }, []);
  return (
    <EmphasizedSnackbarContext.Provider value={{ displayEmphasizedSnackbar: addItem }}>
      {Array.from(items).map(item => (
        <EmphasizedSnackbar
          key={item}
          open
          onClose={() => setItems((currentItems) => {
            currentItems.delete(item);
            return new Set(currentItems); // Must return a new set or else React won't know that we've changed the set
          })}
          title={item.title}
          description={item.description}
          autoHideDuration={item.autoHideDuration}
        />
      ))}
      {children}
    </EmphasizedSnackbarContext.Provider>
  );
}

EmphasizedSnackbarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useEmphasizedSnackbarContext() {
  const context = useContext(EmphasizedSnackbarContext);
  if (!context) throw new Error('useEmphasizedSnackbarContext must be called from a EmphasizedSnackbarContext.Provider');
  return context;
}
